module.exports = __webpack_public_path__ + "r-v3/img/exam_color.bc1f52a0.svg";